import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/video.png'
import _imports_1 from '@/assets/audio.png'
import _imports_2 from '@/assets/file.png'
import _imports_3 from '@/assets/zip.png'


const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = { class: "resource-body" }
const _hoisted_3 = { class: "rc-list" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["onClick", "onDblclick"]
const _hoisted_6 = { class: "li" }
const _hoisted_7 = { class: "li-img" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["alt"]
const _hoisted_13 = ["alt"]
const _hoisted_14 = ["alt"]
const _hoisted_15 = ["alt"]
const _hoisted_16 = ["alt"]
const _hoisted_17 = ["alt"]
const _hoisted_18 = ["alt"]
const _hoisted_19 = ["alt"]
const _hoisted_20 = ["alt"]
const _hoisted_21 = ["alt"]
const _hoisted_22 = ["alt"]
const _hoisted_23 = ["alt"]
const _hoisted_24 = ["alt"]
const _hoisted_25 = ["alt"]
const _hoisted_26 = { class: "li-title" }
const _hoisted_27 = {
  key: 0,
  class: "page"
}
const _hoisted_28 = {
  key: 0,
  class: "ant-pagination-item-link"
}
const _hoisted_29 = {
  key: 1,
  class: "ant-pagination-item-link"
}
const _hoisted_30 = { key: 2 }

import { reactive, ref, toRaw } from 'vue'
import CropperImage from './CropperImage.vue'
import ShotImage from './ShotImage.vue'
import { QueryResourceArgs } from '@/models/args'
import { ResourceDto } from '@/models/dtos'
import { useDataStore, useUserStore } from '@/store'
import { message } from 'ant-design-vue'
import { ScissorOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { ResourceChoosedType } from '@/models/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceModal',
  emits: ['ok'],
  setup(__props, { expose: __expose, emit: __emit }) {

const dataStore = useDataStore()
const userStore = useUserStore()
const loading = ref(false)
const visible = ref(false)
const limitImage = ref(0)
const originalField = ref('')
const list = ref<ResourceDto[]>([])
const choosed = ref<string[]>([])
const fileCount = ref(0)
const uploadFileList = ref<string[]>([])
const createDate = ref()
const cropperImageRef = ref()
const shotImageRef = ref()
const queryParams = reactive<QueryResourceArgs>({
  Type: 0,
  Limit: 36,
  Offset: 0
})

const onOpen = (limit = 0, field = '') => {
  limitImage.value = limit
  originalField.value = field

  const user = userStore.userInfo
  const roleIds = user?.roleIds as Array<number>
  if (!roleIds.includes(1) && !roleIds.includes(2)) {
    queryParams.UserId = user?.id
  }
  getDataList()
  visible.value = true
}

const onClose = () => {
  choosed.value = []
  visible.value = false
}

const onSearch = () => {
  queryParams.Offset = 0
  getDataList()
}

const getDataList = () => {
  loading.value = true
  const q = { ...toRaw(queryParams) }

  if (createDate.value) {
    q.Date = createDate.value.format('YYYY-MM-DD')
  }

  dataStore.getResourceList(q).then(resp => {
    list.value = resp

    loading.value = false
  })
}

const changePage = (page: number) => {
  queryParams.Offset = (page - 1) * (queryParams.Limit as number)
  getDataList()
}

const onShowSizeChange = (current: number, size: number) => {
  queryParams.Limit = size
}

const onChoose = (image) => {
  const s = new Set(choosed.value)
  if (s.has(image)) {
    s.delete(image)
  } else {
    s.add(image)
  }
  choosed.value = Array.from(s)
}

const onCheckChoose = (image: string) => {
  return choosed.value.includes(image)
}

const uploadCropImage = (e) => {
  dataStore.createResource(e).then(() => {
    cropperImageRef.value.onClose()
    shotImageRef.value.onClose()

    queryParams.Offset = 0
    getDataList()
  })
}

const onCropper = (res: ResourceDto) => {
  console.log(res)
}

const beforeUpload = (file, fileList) => {
  fileCount.value = fileList.length
}

const uploads = (e) => {
  loading.value = true
  const formData = new FormData()
  formData.append('file', e.file, e.file.name)

  dataStore.createResource(formData).then(resp => {
    uploadFileList.value.push(resp.url)

    if (uploadFileList.value.length >= fileCount.value) {
      uploadFileList.value = []
      fileCount.value = 0
      queryParams.Offset = 0
      getDataList()
    }
  })
}

// eslint-disable-next-line no-undef
const emit = __emit

const onSubmit = () => {
  if (limitImage.value > 0 && limitImage.value < choosed.value.length) {
    message.error(`最多选择${limitImage.value}个文件`)
    return false
  }

  const imageListRaw = toRaw(list.value)
  const choosedRaw = toRaw(choosed.value)
  const imageList = imageListRaw.filter(x => choosedRaw.find(y => y === x.url))
  emit('ok', {
    images: choosedRaw,
    imageList,
    field: originalField.value
  } as ResourceChoosedType)

  onClose()
}

// eslint-disable-next-line no-undef
__expose({
  onOpen
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_e_modal = _resolveComponent("e-modal")!

  return (_openBlock(), _createBlock(_component_e_modal, {
    visible: visible.value,
    title: "上传资源管理",
    width: 1000,
    onClose: onClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_a_input, {
            value: queryParams.Name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.Name) = $event)),
            placeholder: "文件名",
            allowClear: "",
            style: {"width":"150px","margin-right":"8px"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_date_picker, {
            value: createDate.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((createDate).value = $event)),
            placeholder: "上传日期"
          }, null, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: onSearch
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" 搜索 ")
            ])),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (cropperImageRef.value.open()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ScissorOutlined)),
              _cache[6] || (_cache[6] = _createTextVNode(" 裁剪上传 "))
            ]),
            _: 1
          }),
          _createVNode(_component_a_upload, {
            name: "file",
            customRequest: uploads,
            multiple: "",
            beforeUpload: beforeUpload,
            showUploadList: false,
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadOutlined)),
                  _cache[7] || (_cache[7] = _createTextVNode(" 文件上传 "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (shotImageRef.value.open()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ScissorOutlined)),
              _cache[8] || (_cache[8] = _createTextVNode(" 截图上传 "))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: choosed.value.length === 0,
            onClick: onSubmit
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" 选择 ")
            ])),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, { onClick: onClose }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle(_unref(dataStore).resourceTotal > queryParams.Limit ? 'padding-bottom: 50px' : 'padding-bottom: 0')
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_spin, {
              tip: "加载中...",
              spinning: loading.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v, k) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: k,
                      class: _normalizeClass({
                item: true,
                on: onCheckChoose(v.url),
              }),
                      onClick: ($event: any) => (onChoose(v.url)),
                      onDblclick: ($event: any) => (onCropper(v))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (v.ext.indexOf('jpg') !== -1 || v.ext.indexOf('jpeg') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: v.url,
                                alt: v.name
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('png') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: v.url,
                                alt: v.name
                              }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('gif') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: v.url,
                                alt: v.name
                              }, null, 8, _hoisted_10))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('jfif') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 3,
                                src: v.url,
                                alt: v.name
                              }, null, 8, _hoisted_11))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('video') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 4,
                                src: _imports_0,
                                alt: v.name
                              }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('wav') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 5,
                                src: _imports_1,
                                alt: v.name
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('mp3') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 6,
                                src: _imports_1,
                                alt: v.name
                              }, null, 8, _hoisted_14))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('mp4') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 7,
                                src: _imports_0,
                                alt: v.name
                              }, null, 8, _hoisted_15))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('wmv') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 8,
                                src: _imports_0,
                                alt: v.name
                              }, null, 8, _hoisted_16))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('avi') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 9,
                                src: _imports_0,
                                alt: v.name
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('doc') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 10,
                                src: _imports_2,
                                alt: v.name
                              }, null, 8, _hoisted_18))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('pdf') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 11,
                                src: _imports_2,
                                alt: v.name
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('xls') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 12,
                                src: _imports_2,
                                alt: v.name
                              }, null, 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('ppt') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 13,
                                src: _imports_2,
                                alt: v.name
                              }, null, 8, _hoisted_21))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('txt') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 14,
                                src: _imports_2,
                                alt: v.name
                              }, null, 8, _hoisted_22))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('zip') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 15,
                                src: _imports_3,
                                alt: v.name
                              }, null, 8, _hoisted_23))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('rar') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 16,
                                src: _imports_3,
                                alt: v.name
                              }, null, 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          (v.ext.indexOf('7z') !== -1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 17,
                                src: _imports_3,
                                alt: v.name
                              }, null, 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(v.name), 1)
                      ])
                    ], 42, _hoisted_5))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          (_unref(dataStore).resourceTotal > queryParams.Limit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_a_pagination, {
                  total: _unref(dataStore).resourceTotal,
                  "page-size": queryParams.Limit,
                  "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.Limit) = $event)),
                  "hide-on-single-page": true,
                  "show-size-changer": true,
                  "page-size-options": ['20', '80', '200', '500'],
                  onChange: changePage,
                  onShowSizeChange: onShowSizeChange
                }, {
                  itemRender: _withCtx(({ page, type }) => [
                    (type === 'prev')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_28, "上一页"))
                      : (type === 'next')
                        ? (_openBlock(), _createElementBlock("a", _hoisted_29, " 下一页 "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(page), 1))
                  ]),
                  _: 1
                }, 8, ["total", "page-size"])
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _createVNode(CropperImage, {
        ref_key: "cropperImageRef",
        ref: cropperImageRef,
        onOk: uploadCropImage
      }, null, 512),
      _createVNode(ShotImage, {
        ref_key: "shotImageRef",
        ref: shotImageRef,
        onOk: uploadCropImage
      }, null, 512)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})